module.exports = __webpack_public_path__ + "c2ca96ad6a70adf5ada7893a8d0506c0.jpg";